<template>
    <div style="min-width: 350px;">
        <div v-if="isLoading" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="Loading">Loading...
        </div>
        <div v-else>
            <div class="des_main" style="width: 100%;display: flex; justify-content: center;" @scroll="handleScroll">
                <div class="details-left" style="width: 100%;min-width: 480px;display: flex; justify-content: center;">
                    <el-card style="max-width: 880px">
                        <!-- <img src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png"
                                style="width: 100%" /> -->

                        <PreViewImageList :imageurl="imgurls"></PreViewImageList>
                        <template #footer>
                            <!-- <div>icon</div> -->
                            <div class="desc-box">
                                <div style="width: 70%; text-align: left;">
                                    <div class="img-title">{{ imgtitle }}</div>
                                    <div class="detail-text">
                                        <!-- <p v-for="desc in imgdesc">{{ desc }}</p> -->
                                        <p>{{ imgdesc }}</p>
                                    </div>
                                    <div class="img-tags-box">
                                        <ul>
                                            <li v-for="tag in imgtag" style="width: fit-content;">
                                                <router-link :to="{ name: 'search', query: { tag: tag } }">
                                                    #{{ tag.trim() }}
                                                </router-link>
                                                <!-- <a href="" style="width: fit-content;">#{{ tag }}</a> -->
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="count-num" style="display: flex;">
                                        <div style="display: flex; align-items: center;margin-right: 10px"><el-icon>
                                                <Star />
                                            </el-icon>{{ imglove }}</div>
                                        <div style="display: flex; align-items: center;"><el-icon>
                                                <View />
                                            </el-icon>{{ imgstar }}</div>
                                    </div>
                                    <p class="upload-date">{{ imguploadDate }}</p>
                                    <div class="user-info_l">
                                        <router-link :to="{ name: 'userArt', query: { user_id: imguserId } }">
                                            <div class="user-icon">
                                                <img :src="imguserIcon" alt="#">
                                            </div>
                                        </router-link>
                                        <div>
                                            {{ imgUserName }}
                                        </div>
                                        <el-button>关注</el-button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-card>
                </div>
                <div class="details-right" style="">
                    <div class="user-info_r" style="margin-bottom: 10px;">
                        <div>
                            <router-link :to="{ name: 'userArt', query: { user_id: imguserId } }"
                                style="text-decoration: none; color: black;display: flex;justify-content: space-evenly;align-items: center;">
                                <div class="user-icon">
                                    <img :src="imguserIcon" alt="">
                                </div>
                                <div style="text-align: left; margin-left: 10px;">
                                    <p style="font-size: 1.5rem;">{{ imgUserName }}</p>
                                    <p style="font-size: .8rem;">id: {{ imguserId }}</p>
                                </div>
                            </router-link>
                        </div>
                        <el-button @click="">关注</el-button>
                    </div>
                    <div>
                        <div style="display: flex; justify-content: space-between; width: 90%;">
                            <spn>其他作品</spn>
                            <router-link :to="{ name: 'userArt', query: { user_id: imguserId } }">
                                更多作品
                            </router-link>
                            <!-- <a href=""></a> -->
                        </div>
                        <div class="other-list" style="margin-bottom: 30px;">
                            <!-- <Section :imageData="otherArt"></Section> -->
                            <!-- <img v-for="art in otherArt" :src="art.original_url" alt=""> -->
                            <router-link v-for="art in otherArt"
                                :to="{ name: 'details', query: { img_id: art.picture_id } }">
                                <!-- <el-image style="width: 100%; height: 280px" :src="art.regular_url" fit="cover" /> -->
                                <img :src="art.original_url" alt="#">
                            </router-link>
                        </div>
                    </div>
                    <div>

                    </div>
                </div>
            </div>
            <br>
            <br>
            <div style="display: flex; justify-content: center;">
                <Section illust_title="更多作品" :imageData="imageInfos_new"></Section>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import Section from '@/components/Section copy.vue';
import PreViewImageList from '@/components/PreViewImageList.vue'
// import { getAuId } from '@/Js/get_authorId';

export default {
    name: 'Details',
    data() {
        return {
            isLoading: true,
            fullscreenLoading: ref(true),
            img_id: this.$route.query.img_id,
            imgurls: [],
            imgtitle: '',
            imgdesc: '',
            imgtag: ['兽耳'],
            imglove: '',
            imgstar: '',
            imguploadDate: '',
            imgUserName: '',
            imguserId: '',
            imguserIcon: '',
            otherArt: ['', '', ''],
            imageInfos_new: ''
        }
    },
    components: {
        Section,
        PreViewImageList,
    },
    async created() {
        try {
            await this.loadmainData();
            await this.loadMoreData();
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            this.isLoading = false;
        }
    },
    mounted() {
        this.loadMoreData();
    },
    methods: {
        handleScroll(e) {
            if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight - 500) {
                console.log("滚动到底部");
            }
        },

        async loadmainData() {
            // this.$axios({
            //     url: 'http://localhost:8000/desc/' + this.$route.query.img_id,
            //     method: 'get',
            // }).then(res => {
            //     var imgInfo = res.data.data;
            //     this.imgurls = imgInfo.urls;
            //     this.imgtitle = imgInfo.title;
            //     this.imgdesc = imgInfo.desc;
            //     this.imgtag = imgInfo.tag;
            //     this.imglove = imgInfo.love;
            //     this.imgstar = imgInfo.star;
            //     this.imguploadDate = imgInfo.uploadDate;
            //     this.imgUserName = imgInfo.userName;
            //     this.imguserId = imgInfo.userId.split(':')[1];
            //     this.imguserIcon = imgInfo.userIcon;
            // }).catch(error => {
            //     console.log(error);
            // });

            await this.$axios({
                url: 'http://localhost:3000?id=' + this.$route.query.img_id,
                method: 'get',
            }).then(res => {
                var au_data = res.data;
                this.imgurls = au_data.imgUrls;
                this.imgtag = au_data.tags;
                this.imgtitle = au_data.title;
                this.imglove = au_data.love;
                this.imgdesc = au_data.desc;
                this.imgstar = au_data.star;
                this.imguploadDate = au_data.uploadDate;
                this.imgUserName = au_data.au_name;
                this.imguserId = au_data.au_id;
                this.imguserIcon = au_data.au_icon;
            }).catch(error => {
                console.log(error);
            });
        },

        loadData(imguserId) {
            this.$axios({
                url: "https://www.vilipix.com/api/v1/picture/public?sort=new&type=0&author_user_id=" + imguserId + "&limit=8&offset=0",
                method: 'get',
            }).then(res_2 => {
                this.otherArt = res_2.data.data.rows
            }).catch(error => {
                console.log(error);
            })
        },

        async loadMoreData() {
            var url = "https://api2.vilipix.com/api/v1/picture/public?limit=20&offset=0&tags=" + this.imgtag.join(',');
            await this.$axios.get(url).then(res => {
                this.imageInfos_new = res.data.data.rows;
                // this.count = res.data.data.count; 
            }).catch(error => {
                console.log(error);
            })
        },

        buttonhandel() {
            alert("该功能未实现");
        }
    },
    watch: {
        imguserId(New, old) {
            this.loadData(this.imguserId);
        },

        '$route'(to, from) {
            this.img_id = this.$route.query.img_id
            this.loadmainData();
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },

        imgtag(New, old) {
            this.loadMoreData();
        },
    }
}
</script>

<style scoped>
.desc-box {
    display: flex;
    justify-content: center;
}

.img-title {
    font-size: 1.3rem;
}

.upload-date {
    font-size: .8rem;
}

.user-info_1 {
    display: flex;
}

.user-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.user-icon>img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.user-info_r,
.user-info_l {
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
}

.user-info_r>*,
.user-info_l>* {
    margin-left: 10px;
    text-align: center;
    display: flex;
    align-items: center;
}

/* .user-info_r>button {
    position: absolute;
    right: 0;
} */

/* .other-list {
    display: flex;
    justify-content: center;
} */
.details-right {
    width: 40%;
    justify-content: center;
    padding-left: 20px;
    padding-top: 20px;
}

.other-list {
    margin-top: 10px;
}

.other-list img {
    width: 150px;
    height: 150px;
    object-fit: cover;
    margin-right: 10px;
}

@media screen and (max-width: 960px) {
    .des_main {
        flex-direction: column;
    }

    .details-right {
        width: 100%;
    }
}
</style>
